<template>
  <main class="client-lead-preview">
    <div>
      <svg height="60px" width="60px">
        <use :xlink:href="`#${fileInfo.iconType}`"/>
      </svg>
      <div class="client-lead-preview-minor">
        <span class="client-lead-preview-minor-name">{{fileInfo.filename}}</span>
        <span>{{fileInfo.size}}</span>
      </div>
      <div class="client-lead-preview-primary">
        {{$t('该格式的文件需要在浏览器中打开预览')}}
      </div>
      <div @click="openInWindow" class="client-lead-preview-button">
        <button class="cp lv-bn lv-80 c-btn">
          {{$t('在浏览器打开')}}
        </button>
      </div>
    </div>
  </main>
</template>

<script>
import { openUrlOutside } from '@filez/js-2-native'

export default {
  name: 'ClientLeadPreview',
  props: {
    fileInfo: {
      type:
      Object,
    },
  },
  methods: {
    openInWindow() {
      openUrlOutside({
        url: window.location.href,
      })
    },
  },
}
</script>

<style lang="less" scoped>
.client-lead-preview{
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  text-align: center;
  line-height: 1;
  .client-lead-preview-minor{
    color: #637282;
    margin-top: 12px;
    .client-lead-preview-minor-name{
      margin-right: 5px;
    }
  }
  .client-lead-preview-primary{
    color: #282E3D;
    margin-top: 12px;
  }
  .client-lead-preview-button{
    margin-top: 24px;
    .lv-bn{
      line-height: 1;
    }
  }
}
</style>
